import type { CopyShape } from "@tami/core/intl";

import type { HEADER_PUBLIC_COPY_PT_BR } from "../header.copy";

export const HEADER_PUBLIC_COPY_ES_ES: CopyShape<
  typeof HEADER_PUBLIC_COPY_PT_BR
> = {
  homeAria: "Tãmi — ir al inicio",
  nav: {
    offer: "Qué te ofrece Tãmi",
    testimonials: "Testimonios",
    pricing: "Precios",
  },
  signInDesktop: "entrar",
  signInMobile: "Entrar",
  createAccount: "Crea tu cuenta",
  menuClose: "Cerrar menú",
  menuOpen: "Abrir menú de navegación",
  mobileNavAria: "Menú de navegación",
};
